// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

.sq-live {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-text-3);
  white-space: nowrap;
  padding-inline: 0.25rem;
}
.sq-live i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sq-text-3);
}
.sq-live.is-live {
  color: var(--sq-good);
}
.sq-live.is-live i {
  background: var(--sq-good);
  animation: sq-live-pulse 2s infinite;
}
.sq-live.is-offline {
  color: var(--sq-bad);
}
.sq-live.is-offline i {
  background: var(--sq-bad);
}
.sq-live button {
  min-height: 32px;
  padding: 0;
  color: inherit;
  font: inherit;
  background: none;
  border: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
@media (pointer: coarse) {
  .sq-live button {
    min-height: 44px;
  }
}

@keyframes sq-live-pulse {
  50% {
    opacity: 0.45;
  }
}
.sq-status-site {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.625rem 0.875rem;
}
.sq-status-site > .sq-field {
  flex: 1 1 18rem;
  max-width: 30rem;
  justify-content: flex-end;
}
@media (max-width: 767px) {
  .sq-status-site > .sq-field {
    flex: 1 1 100%;
    max-width: none;
  }
}

.sq-context-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: auto;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-context-cards {
    flex-wrap: nowrap;
    width: calc(100% + var(--sq-page-x) * 2);
    max-width: none;
    margin: 0 calc(var(--sq-page-x) * -1);
    padding-inline: var(--sq-page-x);
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }
  .sq-context-cards::-webkit-scrollbar {
    display: none;
  }
}

.sq-context-card {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  width: 11.5rem;
  padding: 0.45rem 0.6rem;
  font: inherit;
  text-align: left;
  color: inherit;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius-sm);
}
@media (max-width: 767px) {
  .sq-context-card {
    flex: 0 0 12.5rem;
    width: 12.5rem;
    min-height: 44px;
  }
}
.sq-context-card.is-link {
  cursor: pointer;
}
.sq-context-card.is-link:hover {
  border-color: var(--sq-navy);
}
.sq-context-card .sq-muted {
  overflow-wrap: anywhere;
}

.sq-context-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.15rem 0.35rem;
  min-width: 0;
}

.sq-context-card-name {
  font-size: 0.8125rem;
  font-weight: 600;
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (min-width: 992px) {
  .sq-status-summary {
    position: sticky;
    top: 0;
    z-index: 5;
    padding-block: 0.25rem;
    background: var(--sq-bg);
  }
}
@media (max-width: 767px) {
  .sq-status-summary {
    order: 2;
  }
}

.sq-status-controls {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--sq-border);
}
@media (max-width: 767px) {
  .sq-status-controls {
    padding: 0.625rem;
  }
  .sq-status-controls .sq-chips {
    margin-inline: -0.625rem;
    padding-inline: 0.625rem;
  }
}

.sq-status-controls-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  min-width: 0;
}

.sq-status-search {
  flex: 1 1 11rem;
  max-width: 18rem;
}
@media (max-width: 767px) {
  .sq-status-search {
    flex-basis: 6rem;
    max-width: none;
  }
}

@media (max-width: 767px) {
  .sq-status-view {
    display: flex;
    flex: 1 1 100%;
  }
}

@media (max-width: 767px) {
  .sq-status-window.is-machines {
    display: none;
  }
}

.sq-status-compare {
  margin-top: 1rem;
}

.sq-compare-picks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
  padding: 0.75rem 1rem;
  max-height: 16rem;
  overflow-y: auto;
  border-bottom: 1px solid var(--sq-border);
}

.sq-check {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 30px;
  margin: 0;
  font-size: 0.8125rem;
  color: var(--sq-text-2);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.sq-check input {
  width: 16px;
  height: 16px;
  accent-color: var(--sq-navy);
}
.sq-check.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-check {
    min-height: 44px;
  }
}

.sq-machines {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11.5rem, 1fr));
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0.75rem;
}
@media (max-width: 767px) {
  .sq-machines {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0.625rem;
  }
}
.sq-machines > li {
  min-width: 0;
  display: flex;
}

.sq-machine {
  --cat: var(--sq-cat-unknown);
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  width: 100%;
  min-height: 92px;
  padding: 0.625rem 0.75rem 0.625rem 0.875rem;
  font: inherit;
  text-align: left;
  color: inherit;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius-sm);
  box-shadow: inset 4px 0 0 var(--cat);
  cursor: pointer;
  transition: border-color 0.12s ease, background-color 0.12s ease;
}
.sq-machine:hover {
  border-color: var(--sq-navy);
}
.sq-machine.cat-available {
  --cat: var(--sq-cat-available);
}
.sq-machine.cat-ready {
  --cat: var(--sq-cat-ready);
}
.sq-machine.cat-complete {
  --cat: var(--sq-cat-complete);
}
.sq-machine.cat-in-use {
  --cat: var(--sq-cat-in-use);
}
.sq-machine.cat-out-of-order {
  --cat: var(--sq-cat-out-of-order);
}
.sq-machine.cat-error {
  --cat: var(--sq-cat-error);
  background: var(--sq-bad-bg);
  border-color: var(--sq-bad-line);
}

.sq-machine-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
}

.sq-machine-name {
  font-size: 1.0625rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.sq-machine-clock {
  font-size: 0.875rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--sq-text-2);
}

.sq-machine-status {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-text-2);
}
.cat-error .sq-machine-status {
  color: var(--sq-bad);
}

.sq-machine-meta {
  font-size: 0.75rem;
  color: var(--sq-text-3);
  overflow-wrap: anywhere;
}

.sq-machine-door {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sq-warn);
}

.sq-machine-menu-head {
  padding: 0.5rem 1rem 0.625rem;
  border-bottom: 1px solid var(--sq-border);
  margin-bottom: 0.25rem;
}
.MuiDrawer-root .sq-machine-menu-head {
  padding: 0.875rem 1.25rem;
}

.status-timeline-chart {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 0.75rem 1rem 1rem;
}
@media (max-width: 767px) {
  .status-timeline-chart {
    padding: 0.625rem;
  }
}

.status-timeline-zoom-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
}
.status-timeline-zoom-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sq-text-2);
  background: var(--sq-surface);
  border: 1px solid var(--sq-border-strong);
  border-radius: 6px;
  cursor: pointer;
}
.status-timeline-zoom-controls button:hover {
  border-color: var(--sq-navy);
  color: var(--sq-navy);
}
@media (pointer: coarse), (max-width: 767px) {
  .status-timeline-zoom-controls button {
    min-width: 44px;
    height: 44px;
  }
}

.status-timeline-zoom-hint {
  font-size: 0.75rem;
  color: var(--sq-text-3);
  margin-left: 0.25rem;
}

.status-timeline-scroll {
  max-height: min(520px, 62vh);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius-sm);
  background: var(--sq-surface);
}

.status-timeline-body {
  display: flex;
  min-width: 0;
}

.status-timeline-labels {
  flex-shrink: 0;
  border-right: 1px solid var(--sq-border);
  background: var(--sq-surface-2);
  position: sticky;
  left: 0;
  z-index: 2;
}

.status-timeline-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.1rem;
  padding: 0.15rem 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-text);
  border-bottom: 1px solid var(--sq-border);
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
}
.status-timeline-label:hover {
  background: var(--sq-surface-3);
}
.status-timeline-label:focus-visible {
  box-shadow: inset 0 0 0 2px var(--sq-navy);
}
.status-timeline-label.door-open .status-timeline-door {
  background: var(--sq-warn-bg);
  color: var(--sq-warn);
}
.status-timeline-label.axis-spacer {
  border-bottom: none;
  cursor: default;
}
.status-timeline-label.axis-spacer:hover {
  background: transparent;
}

.status-timeline-label-name {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  min-width: 0;
  line-height: 1.15;
}

.status-timeline-door {
  flex-shrink: 0;
  font-size: 0.625rem;
  font-weight: 700;
  padding: 0.05rem 0.28rem;
  border-radius: 3px;
  line-height: 1.2;
}

.status-timeline-label-meta {
  display: block;
  font-size: 0.6875rem;
  font-weight: 500;
  color: var(--sq-text-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  max-width: 100%;
}

.status-timeline-track-wrap {
  flex: 1 1;
  min-width: 0;
  position: relative;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: pan-y;
}
.status-timeline-track-wrap:active {
  cursor: grabbing;
}

.status-timeline-row {
  position: relative;
  border-bottom: 1px solid var(--sq-border);
  box-sizing: border-box;
}
.status-timeline-row:hover {
  background: var(--sq-surface-2);
}

.status-timeline-segment {
  position: absolute;
  top: 6px;
  height: calc(100% - 12px);
  border-radius: 4px;
  border: 1px solid transparent;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0 6px;
  box-sizing: border-box;
  min-width: 2px;
}

.status-timeline-segment.cat-available,
.status-timeline-legend .swatch.cat-available {
  background: rgba(69, 184, 84, 0.85);
  border-color: #45b854;
}
.status-timeline-segment.cat-ready,
.status-timeline-legend .swatch.cat-ready {
  background: repeating-linear-gradient(135deg, rgba(255, 159, 67, 0.92), rgba(255, 159, 67, 0.92) 5px, rgba(255, 196, 140, 0.92) 5px, rgba(255, 196, 140, 0.92) 10px);
  border-color: #e67e22;
}
.status-timeline-segment.cat-complete,
.status-timeline-legend .swatch.cat-complete {
  background: rgba(119, 197, 213, 0.9);
  border-color: #3a9bb0;
}
.status-timeline-segment.cat-in-use,
.status-timeline-legend .swatch.cat-in-use {
  background: rgba(248, 231, 28, 0.85);
  border-color: #d4a017;
}
.status-timeline-segment.cat-error,
.status-timeline-legend .swatch.cat-error {
  background: repeating-linear-gradient(-45deg, rgba(185, 28, 28, 0.92), rgba(185, 28, 28, 0.92) 4px, rgba(127, 29, 29, 0.92) 4px, rgba(127, 29, 29, 0.92) 8px);
  border-color: #7f1d1d;
}
.status-timeline-segment.cat-out-of-order,
.status-timeline-legend .swatch.cat-out-of-order {
  background: rgba(108, 117, 125, 0.75);
  border-color: #6c757d;
}
.status-timeline-segment.cat-unknown,
.status-timeline-legend .swatch.cat-unknown {
  background: rgba(173, 181, 189, 0.75);
  border-color: #adb5bd;
}

.status-timeline-segment.cat-error .status-timeline-segment-label {
  color: rgba(255, 255, 255, 0.95);
}

.status-timeline-segment-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.78);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

.status-timeline-axis {
  position: relative;
  border-top: 1px solid var(--sq-border);
  background: var(--sq-surface-2);
  overflow: hidden;
}

.status-timeline-tick {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;
}
.status-timeline-tick::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 6px;
  background: var(--sq-border-strong);
}
.status-timeline-tick span {
  font-size: 0.6875rem;
  color: var(--sq-text-3);
  white-space: nowrap;
}

.status-timeline-now-marker {
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 3;
}

.status-timeline-now-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  border-left: 1.5px dashed rgba(1, 66, 106, 0.65);
}

.status-timeline-now-label {
  position: absolute;
  top: 0;
  right: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  color: var(--sq-navy);
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.8);
  padding: 0 2px;
  border-radius: 2px;
}

.status-timeline-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem 1rem;
  font-size: 0.75rem;
  color: var(--sq-text-2);
}
.status-timeline-legend .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.status-timeline-legend .swatch {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  border: 1px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/components/maintenance/statusTimeline.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AAnDA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAsDF;AApDE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AAsDJ;AAnDE;EACE,qBAAA;AAqDJ;AAnDI;EACE,0BAAA;EACA,oCAAA;AAqDN;AAjDE;EACE,oBAAA;AAmDJ;AAjDI;EACE,yBAAA;AAmDN;AA/CE;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AAiDJ;AA/CI;EAXF;IAYI,gBAAA;EAkDJ;AACF;;AA9CA;EACE;IACE,aAAA;EAiDF;AACF;AA9CA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;AAgDF;AA9CE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAgDJ;AA9CI;EALF;IAMI,cAAA;IACA,eAAA;EAiDJ;AACF;;AA7CA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAgDF;AA9CE;EAPF;IAQI,iBAAA;IACA,wCAAA;IACA,eAAA;IACA,qCAAA;IACA,gCAAA;IACA,gBAAA;IACA,qBAAA;IACA,iCAAA;EAiDF;EA/CE;IACE,aAAA;EAiDJ;AACF;;AA7CA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,kCAAA;EACA,kCAAA;AAgDF;AA9CE;EAdF;IAeI,iBAAA;IACA,cAAA;IACA,gBAAA;EAiDF;AACF;AA/CE;EACE,eAAA;AAiDJ;AA/CI;EACE,4BAAA;AAiDN;AA7CE;EACE,uBAAA;AA+CJ;;AA3CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AA8CF;;AA3CA;EACE,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AA8CF;;AAzCE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,UAAA;IACA,sBAAA;IACA,wBAAA;EA6CF;AACF;AA3CE;EATF;IAUI,QAAA;EA8CF;AACF;;AA3CA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,yCAAA;AA8CF;AA5CE;EAPF;IAQI,iBAAA;EA+CF;EA7CE;IACE,wBAAA;IACA,wBAAA;EA+CJ;AACF;;AA3CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA8CF;;AA3CA;EACE,eAAA;EACA,gBAAA;AA8CF;AA5CE;EAJF;IAKI,gBAAA;IACA,eAAA;EA+CF;AACF;;AA3CE;EADF;IAEI,aAAA;IACA,cAAA;EA+CF;AACF;;AA3CE;EACE;IACE,aAAA;EA8CJ;AACF;;AA1CA;EACE,gBAAA;AA6CF;;AA1CA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AA6CF;;AA1CA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA6CF;AA3CE;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AA6CJ;AA1CE;EACE,YAAA;EACA,mBAAA;AA4CJ;AAzCE;EAtBF;IAuBI,gBAAA;EA4CF;AACF;;AAvCA;EACE,aAAA;EACA,8DAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AA0CF;AAxCE;EARF;IASI,gDAAA;IACA,iBAAA;EA2CF;AACF;AAzCE;EACE,YAAA;EACA,aAAA;AA2CJ;;AAvCA;EACE,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,eAAA;EACA,gEAAA;AA0CF;AAxCE;EACE,4BAAA;AA0CJ;AAvCE;EAAkB,8BAAA;AA0CpB;AAzCE;EAAc,0BAAA;AA4ChB;AA3CE;EAAiB,6BAAA;AA8CnB;AA7CE;EAAe,2BAAA;AAgDjB;AA/CE;EAAqB,iCAAA;AAkDvB;AAhDE;EACE,0BAAA;EACA,4BAAA;EACA,gCAAA;AAkDJ;;AA9CA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;AAiDF;;AA9CA;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;AAiDF;;AA9CA;EACE,mBAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;AAiDF;;AA9CA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAiDF;AA/CE;EACE,oBAAA;AAiDJ;;AA7CA;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;AAgDF;;AA7CA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAgDF;;AA7CA;EACE,6BAAA;EACA,yCAAA;EACA,sBAAA;AAgDF;AA9CE;EACE,yBAAA;AAgDJ;;AA1CA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,0BAAA;AA6CF;AA3CE;EANF;IAOI,iBAAA;EA8CF;AACF;;AA3CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AA8CF;AA5CE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;AA8CJ;AA5CI;EACE,4BAAA;EACA,qBAAA;AA8CN;AA3CI;EApBF;IAqBI,eAAA;IACA,YAAA;EA8CJ;AACF;;AA1CA;EACE,kBAAA;EACA,uBAAA;EACA,oBAAA;AA6CF;;AA1CA;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,kCAAA;EACA,6BAAA;AA6CF;;AA1CA;EACE,aAAA;EACA,YAAA;AA6CF;;AA1CA;EACE,cAAA;EACA,wCAAA;EACA,+BAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;AA6CF;;AA1CA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA6CF;AA3CE;EACE,+BAAA;AA6CJ;AA1CE;EACE,0CAAA;AA4CJ;AAzCE;EACE,6BAAA;EACA,qBAAA;AA2CJ;AAxCE;EACE,mBAAA;EACA,eAAA;AA0CJ;AAxCI;EACE,uBAAA;AA0CN;;AArCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAwCF;;AArCA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AAwCF;;AArCA;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAwCF;;AArCA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,mBAAA;AAuCF;AArCE;EACE,gBAAA;AAuCJ;;AAnCA;EACE,kBAAA;EACA,yCAAA;EACA,sBAAA;AAsCF;AApCE;EACE,+BAAA;AAsCJ;;AAlCA;EACE,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AAqCF;;AA/BE;;EACE,mCAAA;EACA,qBAAA;AAmCJ;AA9BE;;EACE,oKAAA;EAOA,qBAAA;AA2BJ;AAxBE;;EACE,oCAAA;EACA,qBAAA;AA2BJ;AAxBE;;EACE,oCAAA;EACA,qBAAA;AA2BJ;AAvBE;;EACE,6JAAA;EAOA,qBAAA;AAoBJ;AAjBE;;EACE,qCAAA;EACA,qBAAA;AAoBJ;AAjBE;;EACE,qCAAA;EACA,qBAAA;AAoBJ;;AAhBA;EACE,gCAAA;AAmBF;;AAhBA;EACE,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,sCAAA;EACA,+BAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,MAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAmBF;AAjBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AAmBJ;AAhBE;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;AAkBJ;;AAdA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;AAiBF;;AAdA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gDAAA;AAiBF;;AAdA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;AAiBF;;AAdA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAiBF;AAfE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AAiBJ;AAdE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AAgBJ","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","@import \"../../styles/tokens.scss\";\n\n// Page furniture ------------------------------------------------------------\n\n.sq-live {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--sq-text-3);\n  white-space: nowrap;\n  padding-inline: 0.25rem;\n\n  i {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--sq-text-3);\n  }\n\n  &.is-live {\n    color: var(--sq-good);\n\n    i {\n      background: var(--sq-good);\n      animation: sq-live-pulse 2s infinite;\n    }\n  }\n\n  &.is-offline {\n    color: var(--sq-bad);\n\n    i {\n      background: var(--sq-bad);\n    }\n  }\n\n  button {\n    min-height: 32px;\n    padding: 0;\n    color: inherit;\n    font: inherit;\n    background: none;\n    border: 0;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    cursor: pointer;\n\n    @media (pointer: coarse) {\n      min-height: 44px;\n    }\n  }\n}\n\n@keyframes sq-live-pulse {\n  50% {\n    opacity: 0.45;\n  }\n}\n\n.sq-status-site {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0.625rem 0.875rem;\n\n  > .sq-field {\n    flex: 1 1 18rem;\n    max-width: 30rem;\n    justify-content: flex-end;\n\n    @media (max-width: $bp-phone) {\n      flex: 1 1 100%;\n      max-width: none;\n    }\n  }\n}\n\n.sq-context-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-left: auto;\n  min-width: 0;\n\n  @media (max-width: $bp-phone) {\n    flex-wrap: nowrap;\n    width: calc(100% + var(--sq-page-x) * 2);\n    max-width: none;\n    margin: 0 calc(var(--sq-page-x) * -1);\n    padding-inline: var(--sq-page-x);\n    overflow-x: auto;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n.sq-context-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n  width: 11.5rem;\n  padding: 0.45rem 0.6rem;\n  font: inherit;\n  text-align: left;\n  color: inherit;\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius-sm);\n\n  @media (max-width: $bp-phone) {\n    flex: 0 0 12.5rem;\n    width: 12.5rem;\n    min-height: 44px;\n  }\n\n  &.is-link {\n    cursor: pointer;\n\n    &:hover {\n      border-color: var(--sq-navy);\n    }\n  }\n\n  .sq-muted {\n    overflow-wrap: anywhere;\n  }\n}\n\n.sq-context-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.15rem 0.35rem;\n  min-width: 0;\n}\n\n.sq-context-card-name {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n// Sits under the page while the machine list scrolls past on desktop.\n.sq-status-summary {\n  @media (min-width: 992px) {\n    position: sticky;\n    top: 0;\n    z-index: 5;\n    padding-block: 0.25rem;\n    background: var(--sq-bg);\n  }\n\n  @media (max-width: $bp-phone) {\n    order: 2;\n  }\n}\n\n.sq-status-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--sq-border);\n\n  @media (max-width: $bp-phone) {\n    padding: 0.625rem;\n\n    .sq-chips {\n      margin-inline: -0.625rem;\n      padding-inline: 0.625rem;\n    }\n  }\n}\n\n.sq-status-controls-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.75rem;\n  min-width: 0;\n}\n\n.sq-status-search {\n  flex: 1 1 11rem;\n  max-width: 18rem;\n\n  @media (max-width: $bp-phone) {\n    flex-basis: 6rem;\n    max-width: none;\n  }\n}\n\n.sq-status-view {\n  @media (max-width: $bp-phone) {\n    display: flex;\n    flex: 1 1 100%;\n  }\n}\n\n.sq-status-window {\n  @media (max-width: $bp-phone) {\n    &.is-machines {\n      display: none;\n    }\n  }\n}\n\n.sq-status-compare {\n  margin-top: 1rem;\n}\n\n.sq-compare-picks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 1rem;\n  padding: 0.75rem 1rem;\n  max-height: 16rem;\n  overflow-y: auto;\n  border-bottom: 1px solid var(--sq-border);\n}\n\n.sq-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 30px;\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--sq-text-2);\n  cursor: pointer;\n  user-select: none;\n\n  input {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--sq-navy);\n  }\n\n  &.is-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    min-height: 44px;\n  }\n}\n\n// Machine cards -------------------------------------------------------------\n\n.sq-machines {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(11.5rem, 1fr));\n  gap: 0.5rem;\n  list-style: none;\n  margin: 0;\n  padding: 0.75rem;\n\n  @media (max-width: $bp-phone) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    padding: 0.625rem;\n  }\n\n  > li {\n    min-width: 0;\n    display: flex;\n  }\n}\n\n.sq-machine {\n  --cat: var(--sq-cat-unknown);\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  width: 100%;\n  min-height: 92px;\n  padding: 0.625rem 0.75rem 0.625rem 0.875rem;\n  font: inherit;\n  text-align: left;\n  color: inherit;\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius-sm);\n  box-shadow: inset 4px 0 0 var(--cat);\n  cursor: pointer;\n  transition: border-color 0.12s ease, background-color 0.12s ease;\n\n  &:hover {\n    border-color: var(--sq-navy);\n  }\n\n  &.cat-available { --cat: var(--sq-cat-available); }\n  &.cat-ready { --cat: var(--sq-cat-ready); }\n  &.cat-complete { --cat: var(--sq-cat-complete); }\n  &.cat-in-use { --cat: var(--sq-cat-in-use); }\n  &.cat-out-of-order { --cat: var(--sq-cat-out-of-order); }\n\n  &.cat-error {\n    --cat: var(--sq-cat-error);\n    background: var(--sq-bad-bg);\n    border-color: var(--sq-bad-line);\n  }\n}\n\n.sq-machine-top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.sq-machine-name {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.sq-machine-clock {\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--sq-text-2);\n}\n\n.sq-machine-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--sq-text-2);\n\n  .cat-error & {\n    color: var(--sq-bad);\n  }\n}\n\n.sq-machine-meta {\n  font-size: 0.75rem;\n  color: var(--sq-text-3);\n  overflow-wrap: anywhere;\n}\n\n.sq-machine-door {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--sq-warn);\n}\n\n.sq-machine-menu-head {\n  padding: 0.5rem 1rem 0.625rem;\n  border-bottom: 1px solid var(--sq-border);\n  margin-bottom: 0.25rem;\n\n  .MuiDrawer-root & {\n    padding: 0.875rem 1.25rem;\n  }\n}\n\n// Timeline chart ------------------------------------------------------------\n\n.status-timeline-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem 1rem;\n\n  @media (max-width: $bp-phone) {\n    padding: 0.625rem;\n  }\n}\n\n.status-timeline-zoom-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.375rem;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 30px;\n    height: 30px;\n    padding: 0 0.5rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: var(--sq-text-2);\n    background: var(--sq-surface);\n    border: 1px solid var(--sq-border-strong);\n    border-radius: 6px;\n    cursor: pointer;\n\n    &:hover {\n      border-color: var(--sq-navy);\n      color: var(--sq-navy);\n    }\n\n    @media (pointer: coarse), (max-width: $bp-phone) {\n      min-width: 44px;\n      height: 44px;\n    }\n  }\n}\n\n.status-timeline-zoom-hint {\n  font-size: 0.75rem;\n  color: var(--sq-text-3);\n  margin-left: 0.25rem;\n}\n\n.status-timeline-scroll {\n  max-height: min(520px, 62vh);\n  overflow-y: auto;\n  overflow-x: hidden;\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius-sm);\n  background: var(--sq-surface);\n}\n\n.status-timeline-body {\n  display: flex;\n  min-width: 0;\n}\n\n.status-timeline-labels {\n  flex-shrink: 0;\n  border-right: 1px solid var(--sq-border);\n  background: var(--sq-surface-2);\n  position: sticky;\n  left: 0;\n  z-index: 2;\n}\n\n.status-timeline-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.1rem;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--sq-text);\n  border-bottom: 1px solid var(--sq-border);\n  box-sizing: border-box;\n  cursor: pointer;\n  overflow: hidden;\n\n  &:hover {\n    background: var(--sq-surface-3);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px var(--sq-navy);\n  }\n\n  &.door-open .status-timeline-door {\n    background: var(--sq-warn-bg);\n    color: var(--sq-warn);\n  }\n\n  &.axis-spacer {\n    border-bottom: none;\n    cursor: default;\n\n    &:hover {\n      background: transparent;\n    }\n  }\n}\n\n.status-timeline-label-name {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  min-width: 0;\n  line-height: 1.15;\n}\n\n.status-timeline-door {\n  flex-shrink: 0;\n  font-size: 0.625rem;\n  font-weight: 700;\n  padding: 0.05rem 0.28rem;\n  border-radius: 3px;\n  line-height: 1.2;\n}\n\n.status-timeline-label-meta {\n  display: block;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: var(--sq-text-3);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n  max-width: 100%;\n}\n\n.status-timeline-track-wrap {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  cursor: grab;\n  user-select: none;\n  // Vertical swipes scroll the page; only horizontal drags pan the chart.\n  touch-action: pan-y;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.status-timeline-row {\n  position: relative;\n  border-bottom: 1px solid var(--sq-border);\n  box-sizing: border-box;\n\n  &:hover {\n    background: var(--sq-surface-2);\n  }\n}\n\n.status-timeline-segment {\n  position: absolute;\n  top: 6px;\n  height: calc(100% - 12px);\n  border-radius: 4px;\n  border: 1px solid transparent;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  padding: 0 6px;\n  box-sizing: border-box;\n  min-width: 2px;\n}\n\n// Shared by the bars and the legend so the two can't drift apart.\n.status-timeline-segment,\n.status-timeline-legend .swatch {\n  &.cat-available {\n    background: rgba(69, 184, 84, 0.85);\n    border-color: #45b854;\n  }\n\n  // Ready and Available sit side by side and are close for red-green colour\n  // blindness, so Ready also carries a texture.\n  &.cat-ready {\n    background: repeating-linear-gradient(\n      135deg,\n      rgba(255, 159, 67, 0.92),\n      rgba(255, 159, 67, 0.92) 5px,\n      rgba(255, 196, 140, 0.92) 5px,\n      rgba(255, 196, 140, 0.92) 10px\n    );\n    border-color: #e67e22;\n  }\n\n  &.cat-complete {\n    background: rgba(119, 197, 213, 0.9);\n    border-color: #3a9bb0;\n  }\n\n  &.cat-in-use {\n    background: rgba(248, 231, 28, 0.85);\n    border-color: #d4a017;\n  }\n\n  // Hatching keeps errors distinguishable without relying on red.\n  &.cat-error {\n    background: repeating-linear-gradient(\n      -45deg,\n      rgba(185, 28, 28, 0.92),\n      rgba(185, 28, 28, 0.92) 4px,\n      rgba(127, 29, 29, 0.92) 4px,\n      rgba(127, 29, 29, 0.92) 8px\n    );\n    border-color: #7f1d1d;\n  }\n\n  &.cat-out-of-order {\n    background: rgba(108, 117, 125, 0.75);\n    border-color: #6c757d;\n  }\n\n  &.cat-unknown {\n    background: rgba(173, 181, 189, 0.75);\n    border-color: #adb5bd;\n  }\n}\n\n.status-timeline-segment.cat-error .status-timeline-segment-label {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.status-timeline-segment-label {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.78);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n}\n\n.status-timeline-axis {\n  position: relative;\n  border-top: 1px solid var(--sq-border);\n  background: var(--sq-surface-2);\n  overflow: hidden;\n}\n\n.status-timeline-tick {\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 4px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 1px;\n    height: 6px;\n    background: var(--sq-border-strong);\n  }\n\n  span {\n    font-size: 0.6875rem;\n    color: var(--sq-text-3);\n    white-space: nowrap;\n  }\n}\n\n.status-timeline-now-marker {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 3;\n}\n\n.status-timeline-now-line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  border-left: 1.5px dashed rgba(1, 66, 106, 0.65);\n}\n\n.status-timeline-now-label {\n  position: absolute;\n  top: 0;\n  right: 4px;\n  font-size: 0.625rem;\n  font-weight: 600;\n  color: var(--sq-navy);\n  white-space: nowrap;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n.status-timeline-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.375rem 1rem;\n  font-size: 0.75rem;\n  color: var(--sq-text-2);\n\n  .legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n  }\n\n  .swatch {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 3px;\n    border: 1px solid transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
